var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import WixComponent from '../BaseComponents/WixComponent';
import omit from 'omit';
import DropdownLayout from '../DropdownLayout/DropdownLayout';
import Button from '../Button';

var ButtonWithOptions = function (_WixComponent) {
  _inherits(ButtonWithOptions, _WixComponent);

  _createClass(ButtonWithOptions, [{
    key: 'dropdownClasses',

    // Abstraction
    value: function dropdownClasses() {}
  }, {
    key: 'dropdownAdditionalProps',
    value: function dropdownAdditionalProps() {}
  }]);

  function ButtonWithOptions(props) {
    _classCallCheck(this, ButtonWithOptions);

    var _this = _possibleConstructorReturn(this, (ButtonWithOptions.__proto__ || Object.getPrototypeOf(ButtonWithOptions)).call(this, props));

    _this.state = {
      showOptions: false
    };

    _this._onSelect = _this._onSelect.bind(_this);
    _this._onKeyDown = _this._onKeyDown.bind(_this);
    _this.hideOptions = _this.hideOptions.bind(_this);
    _this.showOptions = _this.showOptions.bind(_this);
    _this._onCloseKey = _this._onCloseKey.bind(_this);
    _this._renderDropdownLayout = _this._renderDropdownLayout.bind(_this);
    _this.closeOnSelect = _this.closeOnSelect.bind(_this);

    if (props.children) {
      _this.sortChildren(props);
    }
    return _this;
  }

  _createClass(ButtonWithOptions, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.sortChildren(nextProps);
    }
  }, {
    key: 'sortChildren',
    value: function sortChildren(props) {
      var _React$Children$toArr = React.Children.toArray(props.children);

      var _React$Children$toArr2 = _toArray(_React$Children$toArr);

      this.buttonElement = _React$Children$toArr2[0];
      this.optionsElement = _React$Children$toArr2.slice(1);
    }
  }, {
    key: 'onClickOutside',
    value: function onClickOutside() {
      this.hideOptions();
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      return React.cloneElement(this.buttonElement, {
        onClick: this.showOptions
      });
    }
  }, {
    key: '_renderDropdownLayout',
    value: function _renderDropdownLayout() {
      var _this2 = this;

      var dropdownProps = Object.assign(omit(['dataHook'], this.props), this.dropdownAdditionalProps());
      var customStyle = { marginLeft: this.props.dropdownOffsetLeft };
      if (this.props.dropdownWidth) {
        customStyle.width = this.props.dropdownWidth;
      }

      var dropdownLayoutOptions = React.Children.map(this.optionsElement, function (option) {
        var _option$props = option.props,
            value = _option$props.children,
            rest = _objectWithoutProperties(_option$props, ['children']);

        return _extends({ value: value }, rest);
      });
      return React.createElement(
        'div',
        { className: this.dropdownClasses(), style: customStyle },
        React.createElement(DropdownLayout, _extends({
          ref: function ref(dropdownLayout) {
            return _this2.dropdownLayout = dropdownLayout;
          }
        }, dropdownProps, {
          options: dropdownLayoutOptions,
          theme: this.props.theme,
          visible: this.state.showOptions,
          onClose: this.hideOptions,
          onSelect: this._onSelect,
          onClickOutside: this.hideOptions
        }))
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          dropDirectionUp = _props.dropDirectionUp,
          style = _props.style;

      var sizeRestrictionStyles = this.props.restrainDropdownSize ? { display: 'inline-block' } : {};
      var customStyle = Object.assign({}, sizeRestrictionStyles, style);
      return React.createElement(
        'div',
        { style: customStyle },
        dropDirectionUp ? this._renderDropdownLayout() : null,
        React.createElement(
          'div',
          { onKeyDown: this._onKeyDown, onFocus: this._onFocus },
          this.renderButton()
        ),
        !dropDirectionUp ? this._renderDropdownLayout() : null
      );
    }
  }, {
    key: 'hideOptions',
    value: function hideOptions() {
      this.setState({ showOptions: false });
    }
  }, {
    key: 'showOptions',
    value: function showOptions() {
      this.setState({ showOptions: true });
    }
  }, {
    key: 'closeOnSelect',
    value: function closeOnSelect() {
      return this.props.closeOnSelect;
    }
  }, {
    key: '_onCloseKey',
    value: function _onCloseKey() {
      if (this.closeOnSelect()) {
        this.hideOptions();
      }
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(option, isSelectedOption) {
      this.showOptions();
      var onSelect = this.props.onSelect;


      if (this.closeOnSelect()) {
        this.hideOptions();
      }

      if (isSelectedOption) {
        this.setState({ showOptions: false });
      } else if (onSelect) {
        onSelect(option);
      }
    }
  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(event) {
      if (!this.dropdownLayout._onKeyDown(event)) {
        switch (event.key) {
          case 'Enter':
          case 'Tab':
            {
              this._onCloseKey();
              break;
            }
          default:
            this.showOptions();
        }
      }
    }
  }]);

  return ButtonWithOptions;
}(WixComponent);

ButtonWithOptions.defaultProps = _extends({}, DropdownLayout.defaultProps, {
  onSelect: function onSelect() {},
  options: [],
  closeOnSelect: true,
  valueParser: function valueParser(option) {
    return option.value;
  },
  dropdownOffsetLeft: '0',
  restrainDropdownSize: true
});

ButtonWithOptions.propTypes = _extends({}, DropdownLayout.propTypes, {
  closeOnSelect: PropTypes.bool,
  valueParser: PropTypes.func,
  dropdownWidth: PropTypes.string,
  dropdownOffsetLeft: PropTypes.string,
  restrainDropdownSize: PropTypes.bool,
  children: PropTypes.arrayOf(function (propValue, key) {
    if (key === 0 && propValue[key].type !== ButtonWithOptions.Button) {
      return new Error('ButtonWithOptions: Invalid Prop children, first child must be ButtonWithOptions.Button');
    }

    if (key !== 0) {
      React.Children.forEach(propValue[key], function (item) {
        if (item.type !== ButtonWithOptions.Option) {
          return new Error('ButtonWithOptions: Invalid Prop children was given. Validation failed on child number ' + key);
        }
      });
    }
  })
});

ButtonWithOptions.Option = function () {
  return null;
};
ButtonWithOptions.Option.displayName = 'ButtonWithOptions.Option';

ButtonWithOptions.Button = function (props) {
  return React.createElement(Button, props);
};
ButtonWithOptions.Button.displayName = 'ButtonWithOptions.Button';

export default ButtonWithOptions;
//# sourceMappingURL=ButtonWithOptions.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/ButtonWithOptions/ButtonWithOptions.js